// components/chatbot/RekomendasiMsg.tsx
import { useRecomToMatkul } from "@/hooks/useRecomToMatkul";
import { RekomResult } from "../RekomResult";

interface RekomendasiResultProps {
    selectedItemIds: number[];
}

const RekomendasiMsg = ({ selectedItemIds }: RekomendasiResultProps) => {
    const recoms = useRecomToMatkul();

    if (!recoms) return null;

    return (
        <div className="mt-4">
            <RekomResult
                recoms={recoms}
                mode="selected"
                selectedItemIds={selectedItemIds}
            />
        </div>
    );
};

export default RekomendasiMsg;